import { Heading } from '@chakra-ui/react' 
import TransactionNoticeDataTableHandler from '@Modules/interfaceManagement/gimac/containers/dataTableHandlers/emitter/TransactionNoticeDataTableHandler'

const TransactionNoticePage = () => {
  return (
    <>
        <Heading size="md" mb={"2rem"}>Avis d'Emission de Transaction</Heading>
        <TransactionNoticeDataTableHandler />
    </>
  )
}

export default TransactionNoticePage